import styled from 'styled-components';

import Modal from './common/Modal';

export default function UnsupportedBrowserModal() {
  return (
    <Modal isOpen closeModal={undefined} backgroundColor="rgba(0, 0, 0, 0.75)">
      <Wrapper>
        <Content>
          <Title>This browser is not fully compatible with Arbor</Title>
          <Explanation>We require using Google Chrome.</Explanation>
        </Content>
        <ActionLink target="_blank" href="https://www.google.com/chrome/">
          Download Chrome
        </ActionLink>
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled.div`
  display: flex;
  width: 440px;
  padding: 48px 24px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  border-radius: 16px;
  border: 1px solid var(--border);
  background: var(--background);
  box-shadow: var(--elevation-toast);
  font-family: var(--font-primary);
`;

const Title = styled.h1`
  color: var(--foreground);
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: 120%; /* 28.8px */
  margin: 0;
`;

const Explanation = styled.p`
  color: var(--text-secondary);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: 140%; /* 22.4px */
  margin: 0;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ActionLink = styled.a`
  display: flex;
  height: 48px;
  padding: 16px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: none;
  border-radius: 8px;
  background: var(--primary);
  color: var(--background);
  font-size: var(--text-sm);
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: normal;
  cursor: pointer;
  text-decoration: none;
`;
